import React, {Component} from "react";
import Dialog from '@mui/material/Dialog';
import {DialogTitle, Table, TableBody, TableCell, TableHead, TableRow} from '@mui/material';
import DialogContent from '@mui/material/DialogContent';
import withStyles from "@mui/styles/withStyles";
import {formatDateTime} from "../../utilities/date";

const styles = {
    dialogTable: {
        padding: 0
    }
}

class PaymentHistoryDialog extends Component {

    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        const {classes} = this.props;
        if (!this.props.open) {
            return <></>;
        }
        return (
            <Dialog open={true} onClose={this.props.onClose}>
                <DialogTitle>Payment history</DialogTitle>
                <DialogContent className={classes.dialogTable}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Created</TableCell>
                                <TableCell>Price</TableCell>
                                <TableCell>Status</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.props.payments.map((payment, index) => {
                                let status
                                return (
                                    <TableRow key={index}>
                                        <TableCell>{formatDateTime(new Date(payment.created_at))}</TableCell>
                                        <TableCell>{payment.price?.toFixed(2)} EUR</TableCell>
                                        <TableCell>{payment.current_state}</TableCell>
                                    </TableRow>
                                );
                            })}

                        </TableBody>
                    </Table>
                </DialogContent>
            </Dialog>
        );
    }
}

export default withStyles(styles)(PaymentHistoryDialog);
/*
const mapStateToProps = state => ({
    share_error: state.clusters.share_error,
    clusters: state.clusters.clusters,
});
export default withStyles(styles)(connect(
    mapStateToProps,
    {clear_cluster_share_error, remove_cluster_share, create_cluster_share}
)(ClusterShareDialog));*/
